import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormComponent, ModalComponent } from '@adminprodigydesign/axis';
import { FormsModule } from '@angular/forms';
import { MenuFilterPipe } from '../../shared/pipes/menu-filter.pipe';
import { CartComponent } from '../../shared/components/cart/cart.component';

@NgModule({
  declarations: [CartComponent],
  imports: [
    CommonModule,
    FormComponent,
    MenuFilterPipe,
    FormsModule,
    ModalComponent,
  ],
  exports: [CartComponent],
})
export class UserModule {}
